<template>
  <div class="px-1 pb-3">
    <template v-if="profileMatter">
      <!-- NavigationBreadcrumb para Dashboard (cuando hay sección) -->
      <!-- Revisar este caso de breadcrumb para cuando es profesor y estudiante y secciones -->
      <!-- <NavigationBreadcrumb
        v-if="(user.is_professor || user.is_student) && section"
        :items="breadcrumbItems"
        fabType="dashboard"
        :sectionId="section_id"
        :showPlannification="false"
      ></NavigationBreadcrumb> -->
      <!-- NavigationBreadcrumb para Evaluation (cuando NO hay sección) -->
      <NavigationBreadcrumb
        v-if="!section"
        :items="breadcrumbItems"
        :matterId="egress_profile_matter_id"
        :showEgressProfile="true"
        :showMatrix1="true"
        :showMatrix2="true"
        :showMatrix3="true"
        :showMatrix4="true"
        :showStudyPlan="true"
        :showCurricularMesh="true"
        :showMatterProgram="true"
        :showInstructional="true"
      ></NavigationBreadcrumb>
      <h2 class="mt-3">
        {{
          $getVisibleNames(
            "teaching.mattersessionplanning",
            false,
            "Planificación de la Asignatura"
          )
        }}
      </h2>
      <MatterPresentation
        v-if="profileMatter"
        :Matter="profileMatter"
      ></MatterPresentation>
      <Header
        class="pt-1 pb-4"
        v-if="section && institution"
        :Matter="profileMatter"
        :allows_crud="sectionAllowsCrud"
        :section_id="section_id"
      ></Header>
      <b-tabs content-class="mt-3" v-model="tabIndex">
        <b-tab
          :title="`${$getVisibleNames(
            'teaching.sessionplanning',
            false,
            'Planificación'
          )} ${$t('teaching.sessionPlanningView.institutional')}`"
          v-if="!user.is_student && career && visibleMatterTabKey === 'matter'"
        >
          <SessionTable
            v-if="profileMatter && matter_session_planning"
            :key_label="'matter'"
            :allows_crud="matterTabAllowsCrud"
            :section_id="section_id"
            :egress_profile_matter_id="egress_profile_matter_id"
            :matter_id="profileMatter.matter"
            :filter_list="matter_session_planning"
            :DirectTeachingActivities="direct_teaching_activities"
            :AutonomousTeachingActivities="autonomous_teaching_activity"
            :TeachingSupportResource="teaching_support_resource"
            :BibliographicResources="bibliographic_resources"
            :EvaluationCriteriaContents="evaluation_criteria_contents"
            :available_evaluations="available_evaluations"
            :evaluation_link_field="evaluationLinkField"
          ></SessionTable>
        </b-tab>
        <b-tab
          :title="`
          ${$getVisibleNames(
            'teaching.sessionplanning',
            false,
            'Planificación'
          )} ${$t('teaching.sessionPlanningView.forThe')} ${$getVisibleNames(
            'mesh.egressprofile',
            false,
            'Perfil de Egreso'
          )}
          `"
          v-if="
            egressProfile &&
            career &&
            !user.is_student &&
            visibleMatterTabKey === 'ep_matter'
          "
        >
          <b-button
            class="m-2 button-class"
            size="sm"
            variant="primary"
            @click="copyPlanning('ep_matter', 'matter')"
            v-if="epMatterTabAllowsCrud"
          >
            {{ $t("teaching.sessionPlanningView.copyThe") }}
            {{
              $getVisibleNames(
                "teaching.sessionplanning",
                false,
                "Planificación"
              )
            }}
            {{ $t("teaching.sessionPlanningView.institutional") }}</b-button
          >
          <SessionTable
            v-if="profileMatter && ep_matter_session_planning && egressProfile"
            :key="keyEPMatter"
            :key_label="'ep_matter'"
            :allows_crud="epMatterTabAllowsCrud"
            :section_id="section_id"
            :egress_profile_matter_id="egress_profile_matter_id"
            :filter_list="ep_matter_session_planning"
            :DirectTeachingActivities="direct_teaching_activities"
            :AutonomousTeachingActivities="autonomous_teaching_activity"
            :TeachingSupportResource="teaching_support_resource"
            :BibliographicResources="bibliographic_resources"
            :EvaluationCriteriaContents="evaluation_criteria_contents"
            :available_evaluations="available_evaluations"
            :evaluation_link_field="evaluationLinkField"
          ></SessionTable>
        </b-tab>
        <b-tab
          v-if="section && institution"
          :title="`${$getVisibleNames(
            'teaching.sectionsessionplanning',
            false,
            'Planificación para la Sección'
          )}`"
        >
          <b-button
            class="m-2 button-class"
            @click="copyPlanning('section', 'matter')"
            v-if="sectionAllowsCrud"
          >
            {{ $t("teaching.sessionPlanningView.copyThe") }}
            {{
              $getVisibleNames(
                "teaching.sessionplanning",
                false,
                "Planificación"
              )
            }}
            {{ $t("teaching.sessionPlanningView.institutional") }}</b-button
          >
          <b-button
            class="m-2 button-class"
            @click="copyPlanning('section', 'ep_matter')"
            v-if="sectionAllowsCrud"
          >
            {{ $t("teaching.sessionPlanningView.copyThe") }}
            {{
              $getVisibleNames(
                "teaching.sessionplanning",
                false,
                "Planificación"
              )
            }}
            {{ $t("teaching.sessionPlanningView.ofThe") }}
            {{
              $getVisibleNames("mesh.egressprofile", false, "Perfil de Egreso")
            }}</b-button
          >
          <SessionTable
            v-if="section_id && section_session_planning"
            :key="keySection"
            :key_label="'section'"
            :allows_crud="sectionAllowsCrud"
            :section_id="section_id"
            :egress_profile_matter_id="egress_profile_matter_id"
            :filter_list="section_session_planning"
            :DirectTeachingActivities="direct_teaching_activities"
            :AutonomousTeachingActivities="autonomous_teaching_activity"
            :TeachingSupportResource="teaching_support_resource"
            :BibliographicResources="bibliographic_resources"
            :EvaluationCriteriaContents="evaluation_criteria_contents"
            :available_evaluations="available_evaluations"
            :evaluation_link_field="evaluationLinkField"
          ></SessionTable>
        </b-tab>
      </b-tabs>

      <!-- Navegación -->
    </template>
  </div>
</template>
<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
import { toast } from "@/utils/utils";
export default {
  name: "SessionPlanningView",
  components: {
    Header: () => import("@/components/teaching/Planification/Header"),
    SessionTable: () =>
      import("@/components/teaching/Planification/SessionTable"),
    MatterPresentation: () =>
      import("@/components/teaching/MatterProgram/MatterPresentation"),
    NavigationBreadcrumb: () =>
      import("@/components/reusable/NavigationBreadcrumb"),
  },
  data() {
    return {
      egress_profile_matter_id: Number(
        this.$route.params.egress_profile_matter_id
      ),
      tabIndex: 0,
      section_id: Number(this.$route.params.section_id),
      matter_session_planning: null,
      ep_matter_session_planning: null,
      section_session_planning: null,
      direct_teaching_activities: [],
      autonomous_teaching_activity: [],
      teaching_support_resource: [],
      bibliographic_resources: [],
      evaluation_criteria_contents: [],
      available_evaluations: [],
      keySection: 0,
      keyEPMatter: 0,
    };
  },
  computed: {
    ...mapGetters({
      sections: names.SECTIONS,
      egress_profiles_matters: names.EGRESS_PROFILES_MATTERS,
      egressProfiles: names.EGRESS_PROFILES,
      careers: names.CAREERS,
      institution: "getInstitution",
      user: "getUser",
    }),
    allows_crud() {
      const has_permission = this.$hasPermissions(
        "teaching.change_sessionplanning"
      );
      if (has_permission) return has_permission;
      else return false;
    },
    // Puede administrar la carrera (directivos, superuser o permiso de objeto
    // sobre la facultad/carrera). Antes esta expresión estaba copiada en cada tab.
    canManageCareer() {
      if (!this.career) return false;
      return (
        [
          "DIRECTIVOS ACADÉMICOS INSTITUCIONALES",
          "DIRECTIVOS ACADÉMICOS (CAMPUS)",
        ].some((group) => this.user.group_names.includes(group)) ||
        this.user.is_superuser ||
        this.$hasObjectPermission(
          "mesh.faculty",
          "change",
          this.career.faculty
        ) ||
        this.$hasObjectPermission("mesh.career", "change", this.career.id)
      );
    },
    matterTabAllowsCrud() {
      return this.canManageCareer && this.allows_crud;
    },
    epMatterTabAllowsCrud() {
      if (!this.egressProfile || this.egressProfile.is_closed) return false;
      return this.matterTabAllowsCrud;
    },
    sectionAllowsCrud() {
      if (!this.section || !this.institution) return false;
      return (
        this.institution.actual_period != null &&
        this.institution.actual_period.id == this.section.period &&
        this.allows_crud
      );
    },
    section() {
      if (!this.section_id) return null;
      return this.sections.find((x) => x.id == this.section_id);
    },
    profileMatter() {
      if (!this.egress_profile_matter_id) return null;
      return this.egress_profiles_matters.find(
        (x) => x.id == this.egress_profile_matter_id
      );
    },
    egressProfile() {
      if (!this.profileMatter) return null;
      return this.egressProfiles.find(
        (x) => x.id == this.profileMatter.egress_profile
      );
    },
    career() {
      if (!this.egressProfile) return null;
      return this.careers.find((x) => x.id == this.egressProfile.career);
    },
    visibleMatterTabKey() {
      if (!this.profileMatter) return null;
      return this.profileMatter.use_matter_values ? "matter" : "ep_matter";
    },
    evaluationLinkField() {
      return this.visibleMatterTabKey === "matter"
        ? "matter_evaluation"
        : "egress_profile_matter_evaluation";
    },
    breadcrumbItems() {
      let breadcrumb = [];
      if (this.egressProfile) {
        breadcrumb = [
          {
            text: this.$t("reusable.breadcrumb.home"),
            to: "/home",
          },
          {
            text: this.$getVisibleNames("mesh.career", true, "Programas"),
            to: "/careers",
          },
          {
            text: this.$getVisibleNames("manual.matriz_2", false, "Matriz 2"),
            to: `/matrix2/form/${this.egressProfile.id}`,
            dropdownOptions: [
              "showEgressProfile",
              "showMatrix1",
              "showMatrix2",
              "showMatrix3",
              "showMatrix4",
              "showStudyPlan",
              "showCurricularMesh",
            ],
          },
          {
            text: this.$getVisibleNames(
              "manual.matter_program",
              false,
              "Programa de la Asignatura"
            ),
            to: `/matter/form/${this.egress_profile_matter_id}`,
            dropdownOptions: ["showMatterProgram", "showInstructional"],
          },
        ];
      }
      return breadcrumb;
    },
  },
  methods: {
    copyPlanning(key_label, copy_from) {
      const copy_options = {
        "section-matter": {
          query: `copy_from=matter&section=${this.section_id}`,
        },
        "section-ep_matter": {
          query: `copy_from=ep_matter&section=${this.section_id}`,
        },
        "ep_matter-matter": {
          query: `copy_from=matter&ep_matter=${this.egress_profile_matter_id}`,
        },
      };
      const option = copy_options[`${key_label}-${copy_from}`];
      if (!option) return;
      this.$swal({
        title: this.$t("teaching.sessionPlanningView.copyConfirmTitle"),
        // El backend elimina la sesión de destino con el mismo orden antes de
        // copiar, por eso se advierte que se reemplaza.
        text: this.$t("teaching.sessionPlanningView.copyConfirmText"),
        type: "warning",
        showCancelButton: true,
      }).then((result) => {
        if (!result.value) return;
        this.$restful
          .Post(`/teaching/copy_session_planning/?${option.query}`)
          .then(() => {
            this.reloadCopiedPlanning(key_label);
          })
          .catch(() => {
            toast(this.$t("teaching.sessionPlanningView.copyError"));
          });
      });
    },
    reloadCopiedPlanning(key_label) {
      if (key_label == "section") {
        this.$restful
          .GetAll(
            `/teaching/section-session-planning/?section=${this.section_id}`
          )
          .then((session_planning) => {
            this.section_session_planning = session_planning;
            this.keySection += 1;
          });
      } else if (key_label == "ep_matter") {
        this.$restful
          .GetAll(
            `/teaching/ep-matter-session-planning/?egress_profile_matter=${this.egress_profile_matter_id}`
          )
          .then((session_planning) => {
            this.ep_matter_session_planning = session_planning;
            this.keyEPMatter += 1;
          });
      }
    },
  },
  created() {
    this.$store.dispatch(names.FETCH_TAXONOMIES);
    this.$store.dispatch(names.FETCH_METHODOLOGICAL_STRATEGIES);
    this.$store.dispatch(names.FETCH_TIME_ALLOCATIONS);
    this.$restful.GetAll(`/mesh/direct-teaching-activity/`).then((response) => {
      this.direct_teaching_activities = response.sort((a, b) =>
        a.name.localeCompare(b.name)
      );
    });
    this.$restful
      .GetAll(`/mesh/autonomous-teaching-activity/`)
      .then((response) => {
        this.autonomous_teaching_activity = response.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
      });
    this.$store
      .dispatch(
        names.FETCH_EGRESS_PROFILE_MATTER,
        this.egress_profile_matter_id
      )
      .then((matter) => {
        this.$restful
          .GetAll(
            `/teaching/evaluation-criteria-macro-content/?matter=${matter.matter}`
          )
          .then((response) => {
            this.evaluation_criteria_contents = response;
          });
        this.$store.dispatch(
          names.FETCH_EVALUATION_CRITERIAS_MACROS,
          matter.matter
        );
        this.$store.dispatch(names.FETCH_EGRESS_PROFILE, matter.egress_profile);
        this.$store.dispatch(names.FETCH_EP_MATTER_TIME_ALLOCATIONS, {
          egress_profile_id: matter.egress_profile,
        });
        this.$store.dispatch(names.FETCH_MATTER_TIME_ALLOCATIONS, {
          egress_profile_id: matter.egress_profile,
        });
        this.$store.dispatch(names.FETCH_MATTER, matter.matter);
        this.$store
          .dispatch(names.FETCH_STUDY_UNITS, matter.matter)
          .then((study_units) => {
            this.$store.dispatch(names.FETCH_EVALUATION_CRITERIAS, {
              matter_id: matter.matter,
            });
            // Contenidos de todas las unidades de estudio en un solo
            // request, en vez de uno por unidad (FETCH_CONTENTS no cachea).
            this.$store.dispatch(
              names.FETCH_CONTENTS_BY_STUDY_UNITS,
              study_units.map((study_unit) => study_unit.id)
            );
          });
        this.$restful
          .GetAll(`/teaching/support-resource/?matter=${matter.matter}`)
          .then((response) => {
            this.teaching_support_resource = response;
          });
        this.$restful
          .GetAll(`/teaching/bibliographic-resource/?matter=${matter.matter}`)
          .then((response) => {
            this.bibliographic_resources = response;
          });
        this.$restful
          .GetAll(`/teaching/matter-session-planning/?matter=${matter.matter}`)
          .then((session_planning) => {
            this.matter_session_planning = session_planning;
          });
        this.$restful
          .GetAll(
            `/teaching/ep-matter-session-planning/?egress_profile_matter=${matter.id}`
          )
          .then((session_planning) => {
            this.ep_matter_session_planning = session_planning;
          });
        if (matter.use_matter_values) {
          this.$store
            .dispatch(names.FETCH_MATTER_EVALUATIONS, matter.matter)
            .then((response) => {
              this.available_evaluations = [...response].sort(
                (a, b) => a.order - b.order
              );
            });
        } else {
          this.$restful
            .GetAll(
              `/teaching/egress-profile-matter-evaluation/?egress_profile_matter=${matter.id}`
            )
            .then((response) => {
              this.available_evaluations = response.sort(
                (a, b) => a.order - b.order
              );
            });
        }
      });
    if (this.section_id != 0 && this.section_id != null)
      this.$store
        .dispatch(names.FETCH_SECTION, this.section_id)
        .then((section) => {
          this.$restful
            .GetAll(`/teaching/section-session-planning/?section=${section.id}`)
            .then((session_planning) => {
              this.section_session_planning = session_planning;
            });
        });
  },
};
</script>
<style scoped>
.button-class {
  float: left;
}
</style>